/* DataExplorerResultsViewRenderer.js */

"use strict";
// require("@gluenetworks/jstree");
const _ = require("lodash");
const Registrations = require("../../../../../RegistrationNamespaces");
const formatters = require("./cellFormaters");
const ComboBoxControl = require("@gluenetworks/steve_ui_core").Control.OptionSelection.Single
    .ComboBox;
const MAX_COLUMNS = 5000;
const MAX_CELLS = 500000;

/* global Slick, $, kendo*/

// function countAggregator(field) {
//     this.field_ = field;

//     this.init = function () {
//         this.count_ = 0;
//     };

//     this.accumulate = function (item) {
//         this.count_ += 1;
//     };

//     this.storeResult = function (groupTotals) {
//         if (!groupTotals.count) {
//             groupTotals.count = {};
//         }
//         groupTotals.count[this.field_] = this.count_;
//     };
// }
// Modifying avg aggregator to count null columns
class AvgAggregator {
    constructor(field) {
        this.field_ = field;

        this.init = function () {
            this.count_ = 0;
            this.nonNullCount_ = 0;
            this.sum_ = 0;
        };

        this.accumulate = function (item) {
            let val = item[this.field_];
            this.count_++;
            if (val && !Number.isNaN(val)) {
                this.nonNullCount_++;
                this.sum_ += parseFloat(val);
            }
        };

        this.storeResult = function (groupTotals) {
            if (!groupTotals.avg) {
                groupTotals.avg = {};
            }
            if (this.nonNullCount_ !== 0) {
                groupTotals.avg[this.field_] = this.sum_ / this.count_;
            }
        };
    }
}

class DataExplorerResultsViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("data-explorer-results-view-gl");
        this._rootElem.classList.add("data-explorer-results-view-gl");
        this._rootElem.component = this._model;
        this._logger = this._model.logger;
        this._rootElem.appendChild(this._createNoDataPlaceholder(null, true));
        this._rootElem.classList.add("empty");

        this._topContainer = document.createElement("top-container");

        this._countContainer = document.createElement("result-count");
        this._groupContainer = document.createElement("group-dropdown");
        this._templateNameContainer = document.createElement("t-name");
        this._executionTimeContainer = document.createElement("execution-time");

        this._groupControl = new ComboBoxControl({options: [], showFilter: true});

        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Email",
            name: "EmailTemplate",
            handler: (this._onTemplateEmail = this._onTemplateEmail.bind(this)),
        });

        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Download",
            name: "DownloadTemplate",
            handler: (this._onTemplateDownload = this._onTemplateDownload.bind(this)),
        });

        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Edit Data Selection",
            name: "editTemplate",
            handler: (this._editTemplate = this._editTemplate.bind(this)),
            position: "left",
        });
        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Run Again",
            name: "reRun",
            handler: (this._onReRun = this._onReRun.bind(this)),
            position: "left",
        });
        // this._model.gameEditor.addViewAction({
        //     type: "normal",
        //     displayName: "Add Row",
        //     name: "addRow",
        //     handler: (this._addNewRowAction = this._addNewRowAction.bind(this)),
        //     position: "left"
        // });

        this._model.gameEditor.disableViewAction("DownloadTemplate");
        this._model.gameEditor.disableViewAction("EmailTemplate");
        this._model.gameEditor.disableViewAction("reRun");

        this._columns = undefined;

        this._slickTableContainer = document.createElement("report-table");
        this._slickTable = undefined;

        this._tableOptions = {
            editable: false,
            enableTextSelectionOnCells: true,
            enableCellNavigation: true,
            enableAsyncPostRender: false,
            forceFitColumns: false,
            autoHeight: false,
            autoEdit: false,
            resizable: true,
            rowHeight: 30,
            enableColumnReorder: false,
        };

        // Define kendo pdf font
        kendo.pdf.defineFont({
            oxygenregular: "/styles/fonts/Oxygen/Oxygen-Regular.ttf",
            Oxygen: "/styles/fonts/Oxygen/Oxygen-Regular.ttf",
        });

        this._onRowCountChange = this._onRowCountChange.bind(this);
        this._slickSort = this._slickSort.bind(this);

        this._onWindowResized = _.debounce(this._onWindowResized.bind(this), 300);
        // initiate observer
        this._resObserver = this.observeResize();
        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._groupControl.on(
            "UserValue",
            (this._onGroupingChange = this._onGroupingChange.bind(this))
        );
        this._model.on("SizeChanged", this._onWindowResized);
        window.addEventListener("resize", this._onWindowResized);
    }

    _unregisterListeners() {
        this._groupControl.removeAllListeners("UserValue");
        this._model.removeAllListeners("SizeChanged");
        window.removeEventListener("resize", this._onWindowResized);
    }

    _registerSlickListeners() {
        this._unregisterSlickListeners();
        if (this._slickTable) {
            this._slickDataVIew.onRowCountChanged.subscribe(this._onRowCountChange);
            this._slickTable.onCellChange.subscribe(this._onCellChange);
            this._slickTable.onClick.subscribe(
                (this._onSlickClick = this._onSlickClick.bind(this))
            );
            this._slickTable.onSelectedRowsChanged.subscribe(
                (this._onSlickSelectedRowsChanged = this._onSlickSelectedRowsChanged.bind(this))
            );
            this._slickTable.onBeforeEditCell.subscribe(this._onBeforeEditCell);
            this._slickTable.onSort.subscribe(this._slickSort);
        }
    }

    _unregisterSlickListeners() {
        if (this._slickTable) {
            this._slickDataVIew.onRowCountChanged.unsubscribe(this._onRowCountChange);
            this._slickTable.onCellChange.unsubscribe(this._onCellChange);
            this._slickTable.onClick.unsubscribe(this._onSlickClick);
            this._slickTable.onSelectedRowsChanged.unsubscribe(this._onSlickSelectedRowsChanged);
            this._slickTable.onBeforeEditCell.unsubscribe(this._onBeforeEditCell);
            this._slickTable.onSort.unsubscribe(this._slickSort);
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        this._unregisterSlickListeners();
        this._resObserver.unobserve(document.querySelector(".data-explorer-results-view-gl"));
        let promArr = [];

        return Promise.all(promArr).then(
            () => {
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._aggregators = undefined;
                this._hasAggregates = undefined;
            },
            (err) => {
                this._logger.warn(
                    {error: err},
                    "DataExplorerResultsViewRenderer.shutdown() error."
                );
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        // if (!this._rootElem.hasChildNodes()) {
        //     this._rootElem.appendChild(this._formsComponent.renderer.rootElement);
        // }
        return this._model.whenModelIsReady().then(
            (status) => {
                // console.log(status);
                // console.log(this);

                if (status === "ok") {
                    this._rootElem.innerHTML = "";
                    return this._renderSLickLoading()
                        .then(() => {
                            return this._renderResults();
                        })
                        .then(() => {
                            if (this._model._hasRunPerm) {
                                this._model.gameEditor.enableViewAction("DownloadTemplate");
                                this._model.gameEditor.enableViewAction("EmailTemplate");
                                this._model.gameEditor.enableViewAction("reRun");
                            }
                            this._resObserver.observe(
                                document.querySelector(".data-explorer-results-view-gl")
                            );
                            return this._model._modalUserFeedback.hideDisplayed();
                        });
                }

                // if(status === "running") {
                //     // get work, display veil and then get results.
                //     return this._renderSLickLoading()
                //     .then(() => {
                //         return this._renderProgress();
                //     });
                //     // .then(() => {
                //     //     return this._model._modalUserFeedback.hideDisplayed();
                //     // });
                // }

                if (status === "failed") {
                    {
                        this._rootElem.innerHTML = "";
                        this._rootElem.appendChild(
                            this._createNoDataPlaceholder("Last execution failed")
                        );
                    }
                }
                if (status === "running") {
                    this._rootElem.innerHTML = "";
                    this._rootElem.appendChild(
                        this._createNoDataPlaceholder("Template currently running")
                    );
                }
                if (status === "notexecuted") {
                    this._rootElem.innerHTML = "";
                    this._rootElem.appendChild(
                        this._createNoDataPlaceholder("No results available")
                    );
                }
                return Promise.resolve();
            },
            (err) => err
        );
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE ACTION METHODS            */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE ACTION METHODS              */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _renderProgress() {
        return this._model._templateEntity.loadRelatedExecutions().then((executions) => {
            this._model._execution = executions[0];
            return this._model._execution.loadRelatedWork();
        });
        // .then(work => {
        //     // console.log(work);
        //     // console.log(work.summary);
        // });
    }

    _renderSLickLoading() {
        const veil = this._model._modalUserFeedback.displayLoading({
            message: "Generating the report... ",
        });
        return veil;
    }

    _renderResults() {
        return Promise.resolve().then(() => {
            this._generateSlickData(this._model._execution, this._model._results);
            this._topContainer.appendChild(this._templateNameContainer);
            this._topContainer.appendChild(this._executionTimeContainer);
            this._templateNameContainer.innerHTML = `
                <span class="t-label bold">Description: </span>
                <span class="desc-val" title="${this._model.templateEntity.description}">${
                this._model.templateEntity.description || " - "
            }</span>

            `;
            this._executionTimeContainer.innerHTML = `
                <span class="time-label bold">Last Run: </span>
                <span class="time-val">${this._getDateTime(
                    this._model._execution.completedOn
                )}</span>
            `;
            this._rootElem.appendChild(this._topContainer);

            if (this._tooLargeForTable) {
                const msgEl = document.createElement("div");
                msgEl.className = "de-too-large-msg";
                msgEl.innerHTML = `
                    <p>This report produced results that exceed the display limit of either 5,000 columns or 500,000 cells.</p>
                    <p>Use the Download button to export the full results.</p>
                `;
                this._rootElem.appendChild(msgEl);
                return;
            }

            const groupLabel = document.createElement("label");
            groupLabel.classList.add("bold");
            groupLabel.innerHTML = "Group by: ";
            this._groupContainer.innerHTML = "";
            this._groupContainer.appendChild(groupLabel);
            this._groupContainer.appendChild(this._groupControl.renderer.rootElement);
            this._topContainer.appendChild(this._groupContainer);
            this._topContainer.appendChild(this._countContainer);
            this._countContainer.innerHTML = `
                <span class="text bold">Results: </span>
                <span class="count">${this._slickDataItems.length}</span>
            `;

            this._rootElem.appendChild(this._slickTableContainer);

            this._groupControl.setOptions(
                [].concat(
                    [
                        {
                            label: "None",
                            value: "",
                        },
                    ],
                    this._columns.map((col, idx) => ({
                        label: col.name ? col.name : col.field,
                        value: idx + 1,
                    }))
                )
            );
            this._groupControl.setValue("");

            const groupItemMetadataProvider = new Slick.Data.GroupItemMetadataProvider();
            this._slickDataVIew = new Slick.Data.DataView({
                groupItemMetadataProvider: groupItemMetadataProvider,
                inlineFilters: true,
            });

            this._hasAggregates =
                this._model._execution.aggregators &&
                this._model._execution.aggregators.filter((agg) => !!agg);
            if (this._hasAggregates && this._hasAggregates.length > 0) {
                this._tableOptions.showHeaderRow = true;
                this._tableOptions.headerRowHeight = 30; // updating this value needs changes in css too
            }

            const _windowWidth = window.innerWidth;
            const _columnWidth = this._columns.length * 180;

            if (_columnWidth < _windowWidth) {
                this._tableOptions.forceFitColumns = true;
            }
            // Unregistering slick listeners before initializing to remove dangling listeners
            this._unregisterSlickListeners();
            this._slickDataVIew.setItems(this._slickDataItems);
            this._slickTable = new Slick.Grid(
                this._slickTableContainer,
                this._slickDataVIew,
                this._columns,
                this._tableOptions
            );
            if (this._hasAggregates && this._hasAggregates.length > 0) {
                this._addFooterRow(this._slickTable, this._model._execution);
                this._slickTable.getViewportNode().classList.add("has-footer");
            }
            this._slickTable.registerPlugin(groupItemMetadataProvider);
            this._slickTable.setSelectionModel(new Slick.RowSelectionModel());
            this._registerSlickListeners();
            return Promise.resolve();
        });
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onGroupingChange(val) {
        if (!val) {
            this._slickDataVIew.setGrouping([]);
            return;
        }
        const colIdx = val - 1;
        const columns = this._columns;
        const groupingOpt = {
            getter: columns[colIdx].field,
            formatter: function (g) {
                const _val =
                    g.value === "" || g.value === undefined || g.value === null ? "Blank" : g.value;
                return (
                    columns[colIdx].name +
                    ":  " +
                    _val +
                    "  <span style='color:green'>(" +
                    g.count +
                    " items)</span>"
                );
            },
            collapsed: false,
            // aggregators: [
            //   new countAggregator("_5")
            // ],
            // aggregateCollapsed: false,
            lazyTotalsCalculation: true,
        };
        if (this._aggregators && this._aggregators.length > 0) {
            groupingOpt.aggregators = this._aggregators;
            groupingOpt.aggregateCollapsed = false;
        }
        this._slickDataVIew.setGrouping(groupingOpt);
    }

    _onRowCountChange(e, {current}) {
        // console.time("Row Count");
        this._slickTable.invalidateAllRows();
        this._slickTable.resizeCanvas();
        this._toggleNoDataPlaceholder(!current);
        // console.timeEnd("Row Count");
    }

    _slickSort(e, args) {
        // console.time("Sort");
        // console.time("Sort logic");
        this._slickDataVIew.sort((a, b) => {
            let x = a[args.sortCol.field],
                y = b[args.sortCol.field];
            if (x === null || x === undefined) {
                x = args.sortCol.type === "number" ? 0 : "";
            }
            if (y === null || y === undefined) {
                y = args.sortCol.type === "number" ? 0 : "";
            }
            if (typeof x === "number" && typeof y === "number") {
                return x - y;
            } else {
                if (typeof x === "string") {
                    x = x.toLowerCase();
                }
                if (typeof y === "string") {
                    y = y.toLowerCase();
                }
                return x === y ? 0 : x > y ? 1 : -1;
            }
        }, args.sortAsc);
        // console.timeEnd("Sort logic");
        // console.time("Sort render");
        this._slickTable.invalidate();
        this._slickTable.render();
        // console.timeEnd("Sort render");
        // console.timeEnd("Sort");
    }
    _onSlickClick(e, args) {
        const {cell, row, grid} = args;
        const cellid = grid.getColumns()[cell].id;
        if (cellid === "action_col") {
            const deviceId = e.target.closest("actionable-icon-gl").dataset.device;
            const _type = e.target.closest("actionable-icon-gl").dataset.icon;
            switch (_type) {
                case "configdrift.device_details":
                    this.launchDeviceTab(deviceId, "details");
                    break;
                case "configdrift.eye":
                    this.launchDeviceTab(deviceId, "config");
                    break;
                case "configdrift.snapshot":
                    break;
            }
        }
        const cellNode = grid.getCellNode(row, 1);
        cellNode.closest(".grid-canvas").find(".slick-row").removeClass("selected");
        cellNode.closest(".slick-row").addClass("selected");
    }

    _onSlickSelectedRowsChanged(/*evt, {rows, grid}*/) {
        // console.log("sel", evt, rows, grid);
    }

    _onTemplateDownload() {
        this._model.gameEditor.disableViewAction("DownloadTemplate");
        this._model.gameEditor.setViewActionText("DownloadTemplate", "Downloading...");
        this._model.downloadTemplate().then((resp) => {
            if (_.get(resp, "type") === "pdf" && !_.get(resp, "backendPdf")) {
                this._generateKendoPdf("download", _.get(resp, "fname", "result"));
            } else {
                this._model.gameEditor.enableViewAction("DownloadTemplate");
                this._model.gameEditor.setViewActionText("DownloadTemplate", "Download");
            }
        });
    }

    _onTemplateEmail() {
        this._model.gameEditor.disableViewAction("EmailTemplate");
        this._model.gameEditor.setViewActionText("EmailTemplate", "Sending...");
        this._model.emailReport().then(() => {
            this._model.gameEditor.enableViewAction("EmailTemplate");
            this._model.gameEditor.setViewActionText("EmailTemplate", "Email");
        });
    }

    _editTemplate() {
        this._model.gameEditor.setActiveView(Registrations.DEIE_VIEW_DETAILS);
    }

    _onReRun() {
        // console.log("rerun");
        this._model._isReRun = true;
        this._model
            ._runWork()
            .then(() => {
                this._model._isReRun = false;
                this.render(this._model);
            })
            .catch((err) => {
                this._logger.warn(err);
                if (!err.userRejected) {
                    this._model._modalUserFeedback.displayError(err);
                }
            });
    }

    _onWindowResized() {
        if (this._slickTable) {
            this._slickTable.resizeCanvas();
        }
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _generateSlickData(execEntity, resEntities) {
        const headings = execEntity.heading;
        const aggregators = execEntity.aggregators;
        this._columns = [];
        this._slickDataItems = [];
        this._tooLargeForTable = null;

        const totalCells = resEntities.length * headings.length;
        if (headings.length > MAX_COLUMNS || totalCells > MAX_CELLS) {
            this._tooLargeForTable = {columns: headings.length, rows: resEntities.length};
            return;
        }
        // console.time("Headings");
        this._columns = headings.reduce((acc, heading, idx) => {
            const _width = heading.length * 8 + 20; // approx calc
            acc.push({
                id: heading.replace(/ /gi, "_") + "_" + idx,
                width: _width < 500 ? _width : 500,
                name: heading,
                field: heading.replace(/ /gi, "_") + "_" + idx,
                toolTip: heading,
                groupTotalsFormatter:
                    aggregators && aggregators[idx]
                        ? formatters[`${aggregators[idx]}Formatter`]
                        : formatters.countFormatter,
                sortable: true,
                formatter: formatters.conditionalFormatter,
                maxWidth: 400,
                cssClass: aggregators && aggregators[idx] ? "right" : "",
                headerCssClass: aggregators && aggregators[idx] ? "right" : "",
            });
            return acc;
        }, []);
        this._columns.push({
            id: "action_col",
            width: 80,
            name: "Actions",
            field: "actions",
            toolTip: "Actions",
            formatter: formatters.actionIconsFormatter,
            cssClass: "action-column",
            headerCssClass: "action-column",
        });
        // console.timeEnd("Headings");
        // console.time("Rows");
        this._slickDataItems = resEntities.reduce((acc, ent) => {
            if (!ent || !ent.row) {
                return acc;
            }
            acc.push(
                ent.row.reduce(
                    (acc, f, idx) => {
                        if (this._columns[idx] && !this._columns[idx].type) {
                            this._columns[idx].type = f.dataType;
                        }
                        // if (f.dataType === "number" && !(f.val || f.formattedVal)) {
                        //     f.formattedVal = 0;
                        //     f.val = 0;
                        // }
                        acc[this._columns[idx].field] = f.formattedVal || f.val;
                        if (f.highlightColor) {
                            acc[this._columns[idx].field + ".highlight"] = f.highlightColor;
                        }
                        // Trying to get width with approximate calculation based on string width
                        const _width =
                            typeof acc[this._columns[idx].field] === "string"
                                ? acc[this._columns[idx].field].length * 8 + 20
                                : 80;
                        if (this._columns[idx].width < _width) {
                            this._columns[idx].width = _width <= 500 ? _width : 500;
                        }

                        acc.devId = ent.targetId;
                        return acc;
                    },
                    {id: ent.id}
                )
            );
            return acc;
        }, []);
        // console.timeEnd("Rows");
    }

    _addFooterRow(grid, executionEntity, setAggregators = true) {
        // also set grouping agreagators option from here
        const vals = executionEntity.aggregates;
        const agregators = executionEntity.aggregators;
        const cols = this._columns;
        vals.forEach((val, idx) => {
            let aggregator = agregators && agregators[idx];
            if (aggregator) {
                const colEl = grid.getHeaderRowColumn(cols[idx].field);
                let _text;
                if (aggregator === "sum") {
                    _text = "Sum";
                } else if (aggregator === "average") {
                    _text = "Avg";
                } else {
                    _text = "Sum";
                }
                colEl.innerHTML = `${_text} ${val ? val : 0}`;
                colEl.classList.add("right");
            }

            if (aggregator && setAggregators) {
                if (!this._aggregators) {
                    this._aggregators = [];
                }
                let _aggMethod;
                switch (aggregator) {
                    case "sum":
                        _aggMethod = new Slick.Data.Aggregators.Sum(cols[idx].field);
                        break;
                    case "average":
                        _aggMethod = new AvgAggregator(cols[idx].field);
                        break;
                    default:
                        _aggMethod = new Slick.Data.Aggregators.Sum(cols[idx].field);
                }
                this._aggregators.push(_aggMethod);
            }
        });
    }

    _getDateTime(val) {
        const date = new Date(val);
        return `${date.toLocaleDateString()}, ${date.toLocaleTimeString()}`;
    }

    _createNoDataPlaceholder(msg, veil = false) {
        const noDataPlaceholder = document.createElement("div");
        noDataPlaceholder.classList.add("no-data-placeholder");
        if (veil) {
            noDataPlaceholder.classList.add("dark");
        }
        noDataPlaceholder.innerText = msg || "Initializing result view...";
        return noDataPlaceholder;
    }

    _toggleNoDataPlaceholder(state) {
        this._rootElem.classList.toggle("empty", state);
        this._rootElem.appendChild(this._createNoDataPlaceholder(null, true));
    }

    // Resize observer

    observeResize() {
        const resObs = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.contentRect) {
                    this._model.emit("SizeChanged");
                }
            });
        });
        return resObs;
    }

    launchDeviceTab(id, type) {
        const fqn =
            type === "details" ? Registrations.DIE_VIEW_DETAILS : Registrations.DIE_VIEW_CONFIG;
        const _editorLayout = this._model._gameEditor._editorLayout;
        const deviceIds = _.concat(id || []);
        const stringToHash = deviceIds.join("_");
        //console.log('launch device editor: ', deviceIds); //22411 - debug
        this.generateHash(stringToHash)
            .catch((error) => this._logger.warn({error}))
            .then((tabId) => {
                let launchOpts = _.assign(
                    {},
                    {
                        id: tabId,
                        deviceIds: deviceIds,
                    }
                );

                return _editorLayout
                    .launchEditor({fqn}, Registrations.DEVICE_INSTANCE_EDITOR, launchOpts)
                    .then(() => {
                        return Promise.resolve();
                    });
            });
    }

    generateHash(stringToHash) {
        const encoder = new TextEncoder();
        const data = encoder.encode(stringToHash);

        return window.crypto.subtle.digest("SHA-256", data).then(hexString);

        function hexString(buffer) {
            const byteArray = new Uint8Array(buffer);
            const hexCodes = [...byteArray].map((value) => {
                const hexCode = Number(value).toString(16);
                return hexCode.padStart(2, "0");
            });
            return hexCodes.join("");
        }
    }

    _generateKendoPdf(type, fileName) {
        const _fname = fileName;
        const tempel = $("<div class='temp-slick-grid'></div>");
        $("body").append(tempel);
        const self = this;
        const _tableOptions = Object.assign({}, this._tableOptions, {
            forceFitColumns: false,
            autoHeight: true,
            enableCellNavigation: false,
        });
        const cols = [...this._columns];
        cols.pop();
        const _tempSlick = new Slick.Grid(tempel[0], this._slickDataVIew, cols, _tableOptions);

        this._addFooterRow(_tempSlick, this._model._execution, false);
        tempel.addClass("slick-temp");
        const _dataRowEl = $(".temp-slick-grid");
        // Calculate page break point as per a4 ratio - A4 = 1:1.414 (W:H)
        const _rows = _dataRowEl.find(".ui-widget-content.slick-row");
        const _rw = _rows.first()[0].clientWidth;
        const _pgeH = _rw / 1.415;
        const _rc = Math.floor(_pgeH / 30); // 30 height of each row
        _rows.each(function (idx) {
            if (idx !== 0 && idx % _rc === 0) {
                $(this).addClass("pgbrk");
            }
        });
        const _h = _dataRowEl[0].clientHeight + 90;
        _dataRowEl.css("height", _h + "px");
        _dataRowEl.find(".slick-pane.slick-pane-top.slick-pane-left").css("height", _h + "px");

        const exportSettings = {
            forcePageBreak: ".pgbrk",
            multiPage: true,
            paperSize: "auto",
            landscape: true,
        };

        return this._getKendoPdfData(_dataRowEl, exportSettings).then((data) => {
            if (type === "download") {
                // self._model._modalUserFeedback.hideDisplayed();
                self._model.gameEditor.enableViewAction("DownloadTemplate");
                self._model.gameEditor.setViewActionText("DownloadTemplate", "Download");
                // Save the PDF file
                return kendo.saveAs({
                    dataURI: data,
                    fileName: `${_fname}.pdf`,
                });
            }
            if (type === "email") {
                return data;
            }
        });
    }

    _getKendoPdfData(_dataRowEl, exportSettings) {
        const settings = Object.assign({}, exportSettings, {
            margin: {left: "1cm", top: "1cm", right: "1cm", bottom: "1cm"},
        });
        return Promise.resolve()
            .then(() => {
                return kendo.drawing.drawDOM(_dataRowEl, exportSettings);
            })
            .then((group) => {
                return kendo.drawing.exportPDF(group, settings).done((data) => {
                    return Promise.resolve(data);
                });
            });
    }
    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = DataExplorerResultsViewRenderer;
